export function toggleSmallLoader(){
	if($('.show-load').length){
		$('.show-load').remove();
	}else{
		var loader = '<div class="show-load"><div class="icon"></div></div>';
		$('#search-output').html(loader);
	}
}

export function startLargeLoader(){
	$('#loadItBig').addClass('active');
}

export function endLargeLoader(){
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		$('#loadItBig').removeClass('active');
	}
}

export function startSearchCountLoader()
{
	$('.fullSearchSubmitBtnClass').each(function(i, el) {
		$(el).find('.search-result-loader').removeClass('hidden')
		$(el).find('.search-result-text').addClass('hidden')
	});
}

export function stopSearchCountLoader()
{
	$('.fullSearchSubmitBtnClass').each(function(i, el) {
		$(el).find('.search-result-loader').addClass('hidden')
		$(el).find('.search-result-text').removeClass('hidden')
	});
}